<template>
  <div class="auth-layout-content">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@use '@libero/cityview/modules/app/views/layouts/AuthLayout/AuthLayoutContent.scss';
</style>
